import BaseExecutor from 'services/sports/default/base-executor';
import {MinAdjustedPlayersValidatorBuilder} from 'services/sports/draftkings/validator/min-adjusted-players-validator-builder';
import Action from 'actions';
import BaseValidator from 'services/validations/base-validator';
import {ForcedStackingValidatorBuilder} from 'services/sports/singlegame/validator/forced-stacking-validator-builder';
import {SingleGameValidatorBuilder} from 'services/validations/builders/single-game-validator-builder';

export default class UserAdjustmentsValidatorShowdownBuilder extends BaseExecutor {
    getInterface() {
        const {
            singlegameForcedStacking: {settings: stacking},
        } = Action.getState();

        const validator = new BaseValidator();

        const singleGameValidatorBuilder = new SingleGameValidatorBuilder({
            exposureMinPropNames: ['exposureMin', 'captain_exposureMin'],
        }).getInterface();
        validator.addSubValidators([singleGameValidatorBuilder]);

        if (stacking.isEnabled()) {
            const forcedStackingValidatorBuilder = new ForcedStackingValidatorBuilder().getInterface();
            validator.addSubValidators([forcedStackingValidatorBuilder]);
        }

        if (this._isAnyStackingUsed()) {
            return validator;
        }

        const minAdjustedPlayersValidatorBuilder = new MinAdjustedPlayersValidatorBuilder({
            propNameOfDefaultUserPointsValue: 'adminPoints',
        }).getInterface();
        validator.addSubValidators([minAdjustedPlayersValidatorBuilder]);

        return validator;
    }

    _isAnyStackingUsed() {
        return (
            this._isPlayerNameStackingUsed() ||
            this._isForcedStackingUsed() ||
            this._isPlayerCombinationStackingUsed() ||
            this._isProjectionBoostRuleUsed()
        );
    }

    _isForcedStackingUsed() {
        const {
            singlegameForcedStacking: {settings: stacking},
        } = Action.getState();

        return stacking.isEnabled();
    }

    _isPlayerNameStackingUsed() {
        const {playerNameStacking} = Action.getState();

        return playerNameStacking.isEnabled() && playerNameStacking.hasItems();
    }

    _isPlayerCombinationStackingUsed() {
        const {playerCombinationStacking} = Action.getState();

        return playerCombinationStacking.isEnabled() && playerCombinationStacking.hasItems();
    }

    _isProjectionBoostRuleUsed() {
        const {projectionBoostRule} = Action.getState();

        return projectionBoostRule.isEnabled() && projectionBoostRule.hasItems();
    }
}
